import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';
import Splash from '../images/lyricord_Splash.png'
import Logo from '../images/lyricordLogo.png'
import LyricordIcon from '../images/appIcon240.png'
import LyricordText from '../images/lyricordTextWhite.png'
import StudioBackground from '../images/studioBackground.jpg'

const sizes = {
	desktop: 992,
    tablet: 768,
    logoBreak: 464,
	phone: 376
}

// Iterate through the sizes and create a media template
const media = Object.keys(sizes).reduce((acc, label) => {
	acc[label] = (...args) => css`
		@media (max-width: ${sizes[label] / 16}em) {
			${css(...args)}
		}
	`

	return acc
}, {})

// const Content = styled.div`
// 	height: 3em;
// 	width: 3em;
// 	background: papayawhip;

// 	/* Now we have our methods on media and can use them instead of raw queries */
// 	${media.desktop`background: dodgerblue;`}
// 	${media.tablet`background: mediumseagreen;`}
// 	${media.phone`background: palevioletred;`}
// `

const TopContainer = styled.div`
    background-image: url('${StudioBackground}');
    padding-top: 122px;
    padding-bottom: 195px;
    background-position: 0% 0%;
    background-size: cover;
    background-repeat: repeat;
    color: #fff;
    text-shadow: 1px 1px 6px rgba(0, 0, 0, .37), 0 1px 0 rgba(0, 0, 0, .49);

    ${media.tablet`padding-top: 0px;`}
`

const Content = styled.div`
    padding: 40px;
    padding-left: 10%;
    padding-right: 10%;
    max-width: 800px;
    ${media.tablet`padding: 20px;`}
`

const LogoWrapper = styled.div`
    margin-bottom: 147px;

    ${media.tablet`
        margin-bottom: 50px;
    `}

    ${media.logoBreak`
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 50px;
    `}
`

const LogoIcon = styled.img`
    margin-top: 46px;
    margin-right: 9px;
    float: left;

    ${media.logoBreak`width: 76px; margin-top: 34px;`}
`

const LogoText = styled.img`
    margin-left: 19px;

    ${media.logoBreak`width: 189px;`}
`

const BigText = styled.h1`
    margin-top: 10px;
    margin-bottom: 20px;
    font-size: 56px;
    line-height: 56px;
    font-weight: 700;

    ${media.tablet`font-size: 48px;`}
`

const SubTitle = styled.p`
    margin-top: 0px;
    font-family: 'Varela Round', sans-serif;
    width: 60%;
    margin-bottom: 46px;
    color: #fff;
    font-size: 17px;
    line-height: 21px;

    ${media.phone`width: 100%;`}
    ${media.tablet`width: 100%;`}
    `

const FormLabel = styled.label`
    margin-top: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
    margin-left: 0px;
    padding-top: 0px;
    padding-right: 0px;
    padding-bottom: 0px;
    padding-left: 0px;
    display: block;
    font-weight: bold;
`

const FormInput = styled.input`
    margin: 0;
    display: block;
    height: 20px;
    padding: 8px 12px;
    margin-bottom: 10px;
    font-size: 14px;
    line-height: 1.428571429;
    color: #333333;
    vertical-align: middle;
    background-color: #ffffff;
    border: 1px solid #cccccc;
    width: 290px;
    margin-top: 10px;
    float: left;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
`

const FormSubmit = styled.input`
    display: inline-block;
    padding: 9px 15px;
    background-color: #3898EC;
    color: white;
    border: 0;
    line-height: inherit;
    text-decoration: none;
    cursor: pointer;
    margin-top: 10px;
    margin-left: 15px;
    float: left;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    ${media.logoBreak`margin-left: 0px`}
`

const BarWrapper = styled.div`
    height: 15px;
    display: flex;
    justify-content: space-between;
`

const Bar = styled.div`
    flex: 1;
    background-color: ${props => `${props.color};` || `#fff;`}
`

const IndexPage = () => (
  <div>
    <TopContainer>
        <Content>
            <LogoWrapper>
                <LogoIcon src={LyricordIcon} width={102} /><LogoText src={LyricordText} width={253} />
            </LogoWrapper>
            <BigText>Song Creation Studio.</BigText>
            <SubTitle>
                Lyricord teaches you the basics of songwriting, 
                then gives you the tools to create your own and share them with family, 
                friends, and fans. Just ask Kristi Hoopes, a Lyricord contest winner now 
                appearing on The Voice!
            </SubTitle>
            <form action="//lyricord.us12.list-manage.com/subscribe/post?u=7cfa28a48878a36b5c188aed9&amp;id=43577fd5cb" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank" noValidate>
                <FormLabel>Lyricord will be available again soon. Signup to receive updates!</FormLabel>
                <FormInput type="email" placeholder="Enter your email" id="mce-EMAIL" name="EMAIL" />
                <FormSubmit type="submit" value="Get Notified" name="subscribe" id="mc-embedded-subscribe" />
            </form>
        </Content>
    </TopContainer>
    <BarWrapper>
        <Bar color="whitesmoke" />
        <Bar color="#7eb6f8" />
        <Bar color="#3485ed" />
        <Bar color="#f45553" />
        <Bar color="#3485ed" />
        <Bar color="#7eb6f8" />
        <Bar color="whitesmoke" />
    </BarWrapper>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js